import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosMdfe from './FiltrosAdicionadosMdfe'
import FiltroMdfe from './FiltroMdfe'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroMdfe = () => (
  <Filtro PainelFiltro={FiltroMdfe}/>
);

const PainelFiltrosMdfe = () => (
  <PainelFiltragem
    Filtro={PainelFiltroMdfe}
    FiltrosAdicionados={FiltrosAdicionadosMdfe}/>
)

export default PainelFiltrosMdfe
